import { combineReducers } from 'redux';
import { ActionType, getType } from 'typesafe-actions';

import { GetTyreJanteState, GetTyreListState, GetTyreSeccaoState, GetTyreSerieState, TyreContactState, TyreState } from './Types';

import * as Actions from './Actions';
export type TyreAction = ActionType<typeof Actions>;

const getTyreSeccaoInitialState: GetTyreSeccaoState = {
    isCommunicating: false,
    data: [],
    error: false,
};
const getTyreSerieInitialState: GetTyreSerieState = {
    isCommunicating: false,
    data: [],
    error: false,
};
const getTyreJanteInitialState: GetTyreJanteState = {
    isCommunicating: false,
    data: [],
    error: false,
};
const getTyreListInitialState: GetTyreListState = {
    isCommunicating: false,
    data: [],
    error: false,
};

const tyreContactInitialState: TyreContactState = {
    isCommunicating: false,
    error: false,
};

export default combineReducers<TyreState, TyreAction>({

    getTyreSeccao: (state = getTyreSeccaoInitialState, action) => {
        switch (action.type) {
            case getType(Actions.getTyreSeccaoRequest):
                return {
                    ...state,
                    isCommunicating: true,
                    data: [],
                };
            case getType(Actions.getTyreSeccaoSuccess):
                return {
                    ...state,
                    isCommunicating: false,
                    data: action.payload,
                    error: false,
                };
            case getType(Actions.getTyreSeccaoFailure):
                return {
                    ...state,
                    isCommunicating: false,
                    data: [],
                    error: true,
                };
            default:
                return state;
        }
    },
    getTyreSerie: (state = getTyreSerieInitialState, action) => {
        switch (action.type) {
            case getType(Actions.getTyreSerieRequest):
                return {
                    ...state,
                    isCommunicating: true,
                    data: [],
                };
            case getType(Actions.getTyreSerieSuccess):
                return {
                    ...state,
                    isCommunicating: false,
                    data: action.payload,
                    error: false,
                };
            case getType(Actions.getTyreSerieFailure):
                return {
                    ...state,
                    isCommunicating: false,
                    data: [],
                    error: true,
                };
            default:
                return state;
        }
    },
    getTyreJante: (state = getTyreJanteInitialState, action) => {
        switch (action.type) {
            case getType(Actions.getTyreJanteRequest):
                return {
                    ...state,
                    isCommunicating: true,
                    data: [],
                };
            case getType(Actions.getTyreJanteSuccess):
                return {
                    ...state,
                    isCommunicating: false,
                    data: action.payload,
                    error: false,
                };
            case getType(Actions.getTyreJanteFailure):
                return {
                    ...state,
                    isCommunicating: false,
                    data: [],
                    error: true,
                };
            default:
                return state;
        }
    },
    getTyreList: (state = getTyreListInitialState, action) => {
        switch (action.type) {
            case getType(Actions.getTyreListRequest):
                return {
                    ...state,
                    isCommunicating: true,
                    data: [],
                };
            case getType(Actions.getTyreListSuccess):
                return {
                    ...state,
                    isCommunicating: false,
                    data: action.payload,
                    error: false,
                };
            case getType(Actions.getTyreListFailure):
                return {
                    ...state,
                    isCommunicating: false,
                    data: [],
                    error: true,
                };
            default:
                return state;
        }
    },
    tyreContact: (state = tyreContactInitialState, action) => {
        switch (action.type) {
            case getType(Actions.tyreContactRequest):
                return {
                    ...state,
                    isCommunicating: true,
                };
            case getType(Actions.tyreContactSuccess):
                return {
                    ...state,
                    isCommunicating: false,
                    error: false,
                };
            case getType(Actions.tyreContactFailure):
                return {
                    ...state,
                    isCommunicating: false,
                    error: true,
                };
            default:
                return state;
        }
    },

});
